import React, {useContext} from "react";
import {CustomerTypeContext, isCustomerCompany} from "../../../context/customer-type-context";
import FormatUtils from "../../../utils/FormatUtils";

function BaseInstallment({installment, offer, label, isCreditCalculation}) {

    const customerContext = useContext(CustomerTypeContext);
    const isCompany = isCustomerCompany(customerContext);

    const useGross = isCreditCalculation || !isCompany;
    const priceLabel = useGross ? "brutto" : "netto";

    const catalogPrice = useGross ? offer.basicPriceGross : offer.basicPriceNet;
    const ourPrice = useGross ? offer.minimumPriceGross : offer.minimumPriceNet;

    const hasDiscount = offer.discountVisible && catalogPrice && ourPrice && ourPrice < catalogPrice;
    const discountPct = hasDiscount ? Math.round((1 - ourPrice / catalogPrice) * 100) : 0;

    return (
        <div>
            {hasDiscount && (
                <div className="calc__vehicle-price calc__vehicle-price--catalog">
                    <span className="calc__vehicle-price-label">Cena katalogowa</span>
                    <span className="calc__catalog-price">
                        {FormatUtils.formatMoney(catalogPrice, 0)} <small>{priceLabel}</small>
                    </span>
                </div>
            )}
            <div className="calc__vehicle-price">
                <span className="calc__vehicle-price-label">Nasza cena</span>
                <div className="calc__vehicle-price-right">
                    <span className="calc__vehicle-price-value">
                        {FormatUtils.formatMoney(ourPrice, 0)} <small>{priceLabel}</small>
                    </span>
                    {hasDiscount && (
                        <span className="calc__discount-badge">RABAT -{discountPct}%</span>
                    )}
                </div>
            </div>
        </div>
    );
}

export default BaseInstallment;
